import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useChosenLevel } from '../../hooks/useChosenLevel.js';

export const useActivitySummaryApi = ({ enabled = true } = {}) => {
  const { id } = useChosenLevel();

  return useQuery({
    ...MediaPlan.getActivitySummaryQueryOptions({
      urlParams: {
        mediaDataId: id ?? '',
      },
    }),
    enabled: enabled && !!id,
  });
};
